import NavTab from './navigation-tab';

export default NavTab;